/* ===========================================================================
   REVIVE WEB V2. Composicion de portada
   JavaScript minimo, sin dependencias. Tres responsabilidades y ninguna mas:
     1. Disparar la entrada del hero.
     2. Condensar la cabecera al bajar.
     3. Revelar bloques al entrar en pantalla.
   Toda la animacion vive en CSS; aqui solo se conmutan atributos.
   =========================================================================== */

(() => {
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- 1. Entrada del hero ------------------------------------------------
     Se marca la composicion como lista en el siguiente frame para que el
     navegador tenga un estado inicial que animar. Sin esto la transicion
     se salta y el hero aparece de golpe. */
  const portada = document.querySelector('.rv-portada');
  if (portada) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => portada.setAttribute('data-rv-listo', 'true'));
    });
  }

  /* --- 2. Cabecera al bajar -----------------------------------------------
     IntersectionObserver sobre un centinela, no un listener de scroll: no
     corre en cada frame y el navegador lo resuelve fuera del hilo
     principal. */
  const nav = document.querySelector('.rv-nav');
  const centinela = document.querySelector('[data-rv-centinela]');
  // En páginas internas la cabecera ya es sólida por Liquid: no se conmuta.
  if (nav && centinela && nav.dataset.rvInterna !== 'true' && 'IntersectionObserver' in window) {
    // fijada = true solo cuando el centinela (tras el hero) ha subido por
    // encima del borde superior del viewport. En lo alto de la página el
    // centinela está por debajo del fold: cabecera transparente.
    new IntersectionObserver(
      ([e]) => {
        // Con el carrito o el menu abiertos, body.overflow-hidden oculta la
        // barra de scroll y reflowea: eso disparaba este observador y la
        // cabecera conmutaba sola al cerrar. Mientras haya scroll bloqueado se
        // conserva el estado que ya tenia.
        if (document.body.classList.contains('overflow-hidden')) return;
        const pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        nav.setAttribute('data-rv-fijada', pasado ? 'true' : 'false');
      },
      { rootMargin: '0px', threshold: 0 }
    ).observe(centinela);
  }

  /* --- 3. Aparicion al entrar en pantalla ---------------------------------
     Una sola vez por elemento. Si no hay soporte o el usuario pide menos
     movimiento, todo queda visible desde el principio. */
  const aparecen = document.querySelectorAll('.rv-aparece');
  if (!aparecen.length) return;

  if (menosMovimiento.matches || !('IntersectionObserver' in window)) {
    aparecen.forEach((el) => el.setAttribute('data-rv-visible', 'true'));
    return;
  }

  const obs = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.setAttribute('data-rv-visible', 'true');
        obs.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  aparecen.forEach((el) => obs.observe(el));

  /* --- 4. Video opcional --------------------------------------------------
     Se inyecta el <video> solo si hay fuente y el usuario no pide menos
     movimiento. muted+autoplay+loop+playsinline. Se pausa fuera del
     viewport para no gastar CPU ni bateria con algo que nadie ve. */
  const marco = document.querySelector('[data-rv-video][data-rv-src]');
  if (marco && !menosMovimiento.matches) {
    const src = marco.getAttribute('data-rv-src');
    const poster = marco.querySelector('img, picture');
    const vid = document.createElement('video');
    vid.src = src;
    vid.muted = true; vid.loop = true; vid.playsInline = true;
    vid.setAttribute('playsinline', ''); vid.setAttribute('muted', '');
    vid.preload = 'none';
    vid.className = 'rv-video__medio';
    marco.insertBefore(vid, marco.firstChild);
    if (poster) poster.style.display = 'none';
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { vid.play().catch(() => {}); }
        else { vid.pause(); }
      }, { threshold: 0.25 }).observe(marco);
    } else {
      vid.autoplay = true; vid.play().catch(() => {});
    }
  }

  /* --- 5. EXPLORA: banda horizontal ---------------------------------------
     Flechas de escritorio y señal de "hay más a la derecha". Solo mueve el
     carril en horizontal con scrollBy; nunca toca el scroll vertical de la
     página. El deslizamiento táctil y el teclado ya funcionan de forma nativa
     sobre el contenedor con overflow. Respeta movimiento reducido. */
  document.querySelectorAll('rv-explora').forEach((raiz) => {
    const pista = raiz.querySelector('[data-rv-explora-pista]');
    if (!pista) return;
    const prev = raiz.querySelector('[data-rv-explora="prev"]');
    const next = raiz.querySelector('[data-rv-explora="next"]');
    const comportamiento = menosMovimiento.matches ? 'auto' : 'smooth';

    const paso = () => Math.max(pista.clientWidth * 0.8, 240);
    const estado = () => {
      const max = pista.scrollWidth - pista.clientWidth - 1;
      const x = pista.scrollLeft;
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max;
      raiz.setAttribute('data-rv-fin', x >= max ? 'true' : 'false');
      // Espejo del anterior: el desvanecido izquierdo solo tiene sentido cuando
      // queda algo por ese lado, igual que el derecho.
      raiz.setAttribute('data-rv-inicio', x <= 1 ? 'true' : 'false');
    };

    if (prev) prev.addEventListener('click', () => pista.scrollBy({ left: -paso(), behavior: comportamiento }));
    if (next) next.addEventListener('click', () => pista.scrollBy({ left: paso(), behavior: comportamiento }));
    pista.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });

  /* --- 6. Carrusel compartido (tienda física) --------------------------------
     Mismo patrón horizontal: flechas de escritorio + estado de bordes. Táctil y
     teclado nativos; nunca secuestra el scroll vertical. Reduced motion: salto
     instantáneo. */
  document.querySelectorAll('rv-carrusel').forEach((raiz) => {
    const pista = raiz.querySelector('[data-rv-carrusel-pista]');
    if (!pista) return;
    const prev = raiz.querySelector('[data-rv-carrusel="prev"]');
    const next = raiz.querySelector('[data-rv-carrusel="next"]');
    const comportamiento = menosMovimiento.matches ? 'auto' : 'smooth';
    const paso = () => Math.max(pista.clientWidth * 0.6, 240);
    const estado = () => {
      const max = pista.scrollWidth - pista.clientWidth - 1;
      const x = pista.scrollLeft;
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max;
    };
    if (prev) prev.addEventListener('click', () => pista.scrollBy({ left: -paso(), behavior: comportamiento }));
    if (next) next.addEventListener('click', () => pista.scrollBy({ left: paso(), behavior: comportamiento }));
    pista.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });
})();

/* ===========================================================================
   Menu a pantalla completa. Misma logica accesible que ya validamos:
   <dialog> con showModal para foco atrapado, Escape y top layer, mas un
   fallback si el navegador no lo soporta. El diseno es nuevo; lo que se
   reutiliza es el comportamiento, que estaba bien resuelto.
   =========================================================================== */

class RvMenu extends HTMLElement {
  connectedCallback() {
    this.dialogo = this.querySelector('dialog');
    this.disparador = document.getElementById(this.getAttribute('data-disparador'));
    if (!this.dialogo || !this.disparador) return;

    this.abrir = this.abrir.bind(this);
    this.cerrar = this.cerrar.bind(this);
    this.sincronizar = this.sincronizar.bind(this);
    this.alPulsarTecla = this.alPulsarTecla.bind(this);

    this.soportaModal = typeof this.dialogo.showModal === 'function';
    if (!this.soportaModal) {
      document.body.appendChild(this.dialogo);
      this.dialogo.setAttribute('role', 'dialog');
      this.dialogo.setAttribute('aria-modal', 'true');
      this.dialogo.style.position = 'fixed';
      this.dialogo.style.inset = '0';
      this.dialogo.style.zIndex = '1000';
      this.dialogo.style.display = 'none';
    }

    /* Se cancela la navegacion, igual que hace rv-buscador con su disparador.
       Antes se pasaba `this.abrir` directo, lo que bastaba mientras el unico
       disparador era un <button>. En cuanto el disparador es un enlace real
       (MARCAS, que sin JavaScript debe seguir llevando a su destino), el
       navegador se llevaba la pagina a la vez que se abria el dialogo y la
       navegacion ganaba: parecia que el indice no se desplegaba. */
    this.disparador.addEventListener('click', (e) => { e.preventDefault(); this.abrir(); });
    this.querySelectorAll('[data-rv-cerrar]').forEach((b) => b.addEventListener('click', this.cerrar));
    this.addEventListener('click', (e) => { if (e.target.closest('a[href]')) this.cerrar(); });

    // El atributo open es la unica fuente de verdad: el evento close no
    // llega a dispararse en todos los navegadores cuando hay transiciones
    // sobre overlay y display.
    this.observador = new MutationObserver(this.sincronizar);
    this.observador.observe(this.dialogo, { attributes: true, attributeFilter: ['open'] });
  }

  abrir() {
    if (this.dialogo.open) return;
    if (this.soportaModal) { this.dialogo.showModal(); return; }
    this.focoPrevio = document.activeElement;
    this.dialogo.setAttribute('open', '');
    this.dialogo.style.display = 'block';
    document.addEventListener('keydown', this.alPulsarTecla);
    const primero = this.dialogo.querySelector('[data-rv-cerrar]');
    if (primero) primero.focus();
  }

  cerrar() {
    if (!this.dialogo.open) return;
    if (this.soportaModal) { this.dialogo.close(); return; }
    this.dialogo.removeAttribute('open');
    this.dialogo.style.display = 'none';
    document.removeEventListener('keydown', this.alPulsarTecla);
    if (this.focoPrevio && this.focoPrevio.focus) this.focoPrevio.focus();
    this.focoPrevio = null;
  }

  sincronizar() {
    const abierto = this.dialogo.open;
    this.disparador.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    document.documentElement.classList.toggle('rv-scroll-bloqueado', abierto);
  }

  alPulsarTecla(e) {
    if (e.key === 'Escape') { e.preventDefault(); this.cerrar(); return; }
    if (e.key !== 'Tab') return;
    const sel = 'a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    const f = [...this.dialogo.querySelectorAll(sel)].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const primero = f[0], ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  }

  disconnectedCallback() {
    if (this.observador) this.observador.disconnect();
    document.documentElement.classList.remove('rv-scroll-bloqueado');
  }
}

if (!customElements.get('rv-menu')) customElements.define('rv-menu', RvMenu);

/* ===========================================================================
   Buscador REVIVE. <dialog> en top layer: foco atrapado, Escape y restauración
   de foco los da el navegador. Aquí solo: abrir desde el icono (con progressive
   enhancement), enfocar el campo, bloquear scroll, cerrar por velo/botón y
   evitar acumular listeners. La lógica de resultados es de predictive-search.js.
   =========================================================================== */
class RvBuscador extends HTMLElement {
  connectedCallback() {
    this.dialogo = this.querySelector('dialog');
    this.disparador = document.getElementById(this.getAttribute('data-disparador'));
    this.input = this.querySelector('input[type="search"]');
    if (!this.dialogo || !this.disparador) return;

    this.abrir = this.abrir.bind(this);
    this.cerrar = this.cerrar.bind(this);

    this.soportaModal = typeof this.dialogo.showModal === 'function';

    // Progressive enhancement: sin JS el icono es un enlace a /search.
    this.disparador.addEventListener('click', (e) => { e.preventDefault(); this.abrir(); });
    this.querySelectorAll('[data-rv-cerrar]').forEach((b) => b.addEventListener('click', this.cerrar));
    // Clic en el velo (fuera de la caja) cierra
    this.dialogo.addEventListener('click', (e) => { if (e.target === this.dialogo) this.cerrar(); });
    this.dialogo.addEventListener('close', () => {
      document.documentElement.classList.remove('rv-scroll-bloqueado');
      this.disparador.setAttribute('aria-expanded', 'false');
    });
  }

  abrir() {
    if (this.dialogo.open) return;
    if (this.soportaModal) this.dialogo.showModal(); else this.dialogo.setAttribute('open', '');
    document.documentElement.classList.add('rv-scroll-bloqueado');
    this.disparador.setAttribute('aria-expanded', 'true');
    // Enfocar el campo tras la apertura
    var input = this.input;
    requestAnimationFrame(function () { if (input) input.focus(); });
  }

  cerrar() {
    if (!this.dialogo.open) return;
    if (this.soportaModal) this.dialogo.close(); else this.dialogo.removeAttribute('open');
    document.documentElement.classList.remove('rv-scroll-bloqueado');
  }
}

if (!customElements.get('rv-buscador')) customElements.define('rv-buscador', RvBuscador);

/* --- FAMILY: carril de retratos -------------------------------------------
   Antes esto duplicaba la tira y, al cruzar la mitad, reposicionaba `scrollLeft`
   de golpe para fingir un carril infinito. Ese salto era el origen de los
   "espasmos": es instantaneo, asi que cambia la foto que hay bajo el cursor, y
   el hover salta de una a otra. Estuvo ahi desde el principio y era invisible
   hasta que el acercamiento al pasar el puntero lo delato.

   Se descarta el infinito. Medido antes de decidirlo: el `scale` del hover no
   altera ninguna metrica del carril (scrollWidth, scrollLeft ni las cajas son
   identicas con y sin zoom), asi que lo unico capaz de mover las fotos era ese
   salto. Sin duplicado no hay salto, y sin salto no hay tirones.

   Queda un carril normal: gesto tactil, teclado y anclaje suave. El avance
   automatico se mantiene, porque lo pidio el propietario, pero ahora se detiene
   al llegar al final en vez de dar el salto, y sigue parandose en cuanto alguien
   interactua y no arrancando si el sistema pide menos movimiento. */
(function () {
  var menos = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.rv-people__galeria').forEach(function (pista) {
    if (pista.children.length < 3) return;

    /* --- Arrastre con el puntero -----------------------------------------
       Mantener pulsado y desplazar mueve el carril. Solo para raton: el gesto
       tactil ya desliza solo, con su inercia, y secuestrarlo lo empeoraria.

       Se mueve asignando `scrollLeft` directamente, que es sincrono, en vez de
       animarlo: cualquier animacion peleando con el dedo es exactamente el tipo
       de salto que producia los espasmos que se quitaron aqui.

       Dos cuidados que no se ven pero se notan si faltan: el anclaje
       (`scroll-snap`) se desactiva mientras se arrastra, porque en `proximity`
       tira del carril mientras lo mueves; y un arrastre real anula el click
       posterior, para que mover el carril no te lleve a Instagram sin querer.

       Esto NO depende de `prefers-reduced-motion`: arrastrar es una accion del
       usuario, no decoracion. Lo que sigue respetando esa preferencia es el
       avance automatico. */
    var UMBRAL = 5;
    var arrastrando = false, xInicio = 0, scrollInicio = 0, recorrido = 0, idPuntero = null;

    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastrando = true;
      recorrido = 0;
      xInicio = e.clientX;
      scrollInicio = pista.scrollLeft;
      idPuntero = e.pointerId;
      try { pista.setPointerCapture(idPuntero); } catch (err) { /* sin captura sigue valiendo */ }
      pista.classList.add('rv-people__galeria--arrastrando');
    });

    pista.addEventListener('pointermove', function (e) {
      if (!arrastrando || e.pointerId !== idPuntero) return;
      var d = e.clientX - xInicio;
      if (Math.abs(d) > recorrido) recorrido = Math.abs(d);
      pista.scrollLeft = scrollInicio - d;
      e.preventDefault();
    });

    var soltar = function () {
      if (!arrastrando) return;
      arrastrando = false;
      if (idPuntero !== null) {
        try { pista.releasePointerCapture(idPuntero); } catch (err) { /* ya liberado */ }
      }
      idPuntero = null;
      pista.classList.remove('rv-people__galeria--arrastrando');
    };
    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointercancel', soltar);

    /* En captura, para llegar antes que el <a> del retrato. La anulacion es de
       un solo uso: `recorrido` se limpia justo despues de consultarlo. Sin eso
       se quedaba con el valor del ultimo arrastre y anulaba el siguiente click
       aunque llegara por otra via, por ejemplo con Enter desde el teclado, que
       no pasa por `pointerdown` y por tanto nunca lo habria puesto a cero. */
    pista.addEventListener('click', function (e) {
      var huboArrastre = recorrido > UMBRAL;
      recorrido = 0;
      if (huboArrastre) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* Sin esto el navegador arranca su propio arrastre de imagen y aparece la
       miniatura fantasma pegada al cursor. */
    pista.addEventListener('dragstart', function (e) {
      if (arrastrando) e.preventDefault();
    });

    /* --- Flechas ---------------------------------------------------------
       El mismo cableado que EXPLORA: paso proporcional al ancho visible, estado
       deshabilitado en los extremos y salto instantaneo si el sistema pide
       menos movimiento. Se recalcula tambien al arrastrar, porque el arrastre
       tambien mueve `scrollLeft` y las flechas tienen que enterarse. */
    var seccion = pista.closest('.rv-people') || pista.parentNode;
    var prev = seccion.querySelector('[data-rv-people="prev"]');
    var next = seccion.querySelector('[data-rv-people="next"]');
    if (prev || next) {
      var comportamiento = menos.matches ? 'auto' : 'smooth';
      var salto = function () { return Math.max(pista.clientWidth * 0.8, 240); };
      var estadoFlechas = function () {
        var max = pista.scrollWidth - pista.clientWidth - 1;
        var x = pista.scrollLeft;
        if (prev) prev.disabled = x <= 1;
        if (next) next.disabled = x >= max;
      };
      if (prev) prev.addEventListener('click', function () {
        pista.scrollBy({ left: -salto(), behavior: comportamiento });
      });
      if (next) next.addEventListener('click', function () {
        pista.scrollBy({ left: salto(), behavior: comportamiento });
      });
      pista.addEventListener('scroll', estadoFlechas, { passive: true });
      window.addEventListener('resize', estadoFlechas);
      estadoFlechas();
    }

    if (menos.matches) return;

    var timer = null;
    var paso = function () {
      var item = pista.children[0];
      if (!item) return;
      var max = pista.scrollWidth - pista.clientWidth - 1;
      if (pista.scrollLeft >= max) { parar(); return; }   // final: se detiene, no salta
      var avance = item.getBoundingClientRect().width + 16;
      pista.scrollBy({ left: avance, behavior: 'smooth' });
    };
    var arrancar = function () {
      if (timer || menos.matches) return;
      timer = setInterval(paso, 8000);
    };
    var parar = function () {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    };

    ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
      pista.addEventListener(ev, parar, { passive: true });
    });
    pista.addEventListener('pointerleave', arrancar, { passive: true });
    if (typeof menos.addEventListener === 'function') {
      menos.addEventListener('change', function () { if (menos.matches) parar(); });
    }
    arrancar();
  });
})();

